import { MANAGEWORKSPACE_FAIL, MANAGEWORKSPACE_SUCCESS } from '../actionTypes';

const initialState = {
	user: null,
	loading: false
};

const manageWorkspaceReducer = (state = initialState, action) => {
	switch (action.type) {
		case MANAGEWORKSPACE_SUCCESS:
			return {
				...state,
				loading: true,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case MANAGEWORKSPACE_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default manageWorkspaceReducer;
